// src/config.js
export const API_BASE = "/api/v2/admin";

// Add these new exports below your existing ones:
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://saintsacademy.co.za';

// Email API endpoints
export const EMAIL_API = `${API_BASE_URL}/v2/admin/email-api`;
export const AMBASSADOR_API = `${API_BASE_URL}/v2/admin/ambassador-applications`;

// Payments API
export const PAYMENT_TIERS_API = `${API_BASE_URL}/api/v2/payments/tiers`;

// Add this alias for backward compatibility
export const TIERS_API = PAYMENT_TIERS_API;

// FIX: Add NOTIFICATIONS_API back for components that still use it
export const NOTIFICATIONS_API = `${API_BASE_URL}/v2/admin/email-api?action=subscribe`;

// TEMPORARY FIX - Keep this as fallback
export const MOCK_TIERS = [
  { id: 'free', name: 'Free', price: 0, features: ['Access to free courses', 'Community access'] },
  { id: 'plus', name: 'Plus', price: 199, features: ['All free features', 'Premium courses', 'Priority support'] },
  { id: 'pro', name: 'Pro', price: 399, features: ['All Plus features', 'Certification', '1-on-1 mentorship'] }
];

// Helper function for API calls with better error handling
export const fetchAPI = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    },
    ...options,
  };

  try {
    console.log(`Fetching: ${endpoint}`);
    const response = await fetch(endpoint, defaultOptions);
    
    // Check if response is OK
    if (!response.ok) {
      try {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      } catch (e) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }
    
    // Check content type
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      console.error("Non-JSON response from:", endpoint, text.substring(0, 200));
      throw new Error("Server returned non-JSON response");
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API call failed to ${endpoint}:`, error);
    throw error;
  }
};

// Helper function for email subscriptions
export const subscribeToNotifications = async (email, type = 'course_notification', name = '') => {
  try {
    return await fetchAPI(EMAIL_API + '?action=subscribe', {
      method: 'POST',
      body: JSON.stringify({
        email,
        name,
        type,
        source: window.location.pathname,
        timestamp: new Date().toISOString()
      })
    });
  } catch (error) {
    console.error('Subscription error:', error);
    // Fallback to local storage
    try {
      const subscriptions = JSON.parse(localStorage.getItem('pending_subscriptions') || '[]');
      subscriptions.push({
        email,
        name,
        type,
        timestamp: new Date().toISOString()
      });
      localStorage.setItem('pending_subscriptions', JSON.stringify(subscriptions));
      return { success: true, fallback: true, message: 'Saved locally' };
    } catch (e) {
      return { success: false, error: error.message };
    }
  }
};